<template>
    <div class="flex align-center shop_item">
        <img class="shop-icon" width="20" :src="PLATFORMS_ICONS[shopItem.source]" alt=""/>
        {{shopItem.shortTitle || shopItem.title}}
    </div>
</template>

<script>
import { PLATFORMS_ICONS } from '@/dictionary/platforms.js'
export default {
    props:{
        platform:{
            type:String,
            default:''
        },
        shopId:{
            type:String/Number,
            default:''
        },
        userId:{
            type:String/Number,
            default:''
        },
        shopList:{
            type:Array,
            default(){
                return []
            }
        }
    },
    data(){
        return {
            PLATFORMS_ICONS,
        }
    },
    computed:{
        shopMap(){
            let map = {}
            let shopList = this.shopList
            if(!shopList.length){
                shopList = this.getShopList();
            }
            shopList.forEach(shop => {
                map[shop.id] = shop
            });
            return map
        },
        shopItem(){
            return this.shopMap[this.shopId] || {}
        }
    },
    methods:{
        getShopList(){
            let list = []
            if(this.platform){
                list = this.$store.getters.get_AllShops_BySource(this.platform)
            }
            return list
        },
    }
}
</script>

<style lang="scss" scoped>
.shop_item{
    font-size: 12px;
}
.shop_item + .shop_item{
    margin-left: 8px;
}
.shop-icon{
    margin-right: 4px;
}
</style>